'use strict';

// Intentionally DOES NOT TAKE CONTEXT INTO ACCOUNT
// because it's broken anyway when you add a level of nesting:

// https://github.com/facebook/react/issues/2517
// https://github.com/rackt/react-router/issues/470

// Context changing over time will SCREW YOUR UPDATES
// if there is a component with `shouldComponentUpdate`
// that stands between context owner and consumer,
// doesn't specify THAT EXACT context it in `contextTypes`
// and doesn't take it into account in `shouldComponentUpdate`.

// There is a very easy fix: just DON'T USE THE DAMN CONTEXT.

module.exports = require('react/lib/ReactComponentWithPureRenderMixin');


/** WEBPACK FOOTER **
 ** ./mixins/PureRenderMixin.js
 **/